import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CiCirclePlus } from "react-icons/ci";
import { FaWpforms } from "react-icons/fa";
import { FaRegHeart } from "react-icons/fa";

import "./CommonNavbar.css";
import logo from "../../assets/images/png/Logo.png";
import mobilelogo from "../../assets/images/png/mobile-logo.png";
import plus from "../../assets/images/png/plus.png";
import cartIcon from "../../assets/images/svg/cartIcon.svg";
import { logOutUser } from "../../services/LogOutService";
import { searchProducts } from "../../services/GlobalSearchService";
import {
  CloseIcon,
  HamburgerIcon,
  LogoutIcon,
  SearchIcon,
  UserIcon,
} from "../SvgPaths/SvgPaths";

const useOutsideClick = (ref, callback) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ref, callback]);
};

const Dropdown = ({ title, children, icon }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  useOutsideClick(dropdownRef, () => setIsOpen(false));

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <button onClick={() => setIsOpen(!isOpen)} className="dropdown-toggle">
        {icon ? <span>{icon}</span> : <span className="title">{title}</span>}
      </button>
      {isOpen && <div className="dropdown-menu">{children}</div>}
    </div>
  );
};

const DropdownItem = ({ children, onClick, to }) => {
  const navigate = useNavigate();
  const handleClick = (e) => {
    if (to) {
      e.preventDefault();
      navigate(to);
    }
    if (onClick) onClick();
  };
  return (
    <a href={to || "#"} onClick={handleClick} className="dropdown-item">
      {children}
    </a>
  );
};

const CommonNavbar = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [productsSearch, setProductsSearch] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);

  const searchWrapperRef = useRef(null);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useOutsideClick(searchWrapperRef, () => setShowSearchDropdown(false));

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "visible";
  }, [isMenuOpen]);

  useEffect(() => {
    if (productsSearch.trim() === "") {
      setSearchData([]);
      return;
    }
    const delayDebounceFn = setTimeout(async () => {
      const res = await searchProducts(productsSearch);
      setSearchData(res);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [productsSearch]);

  const handleLogout = async () => {
    await logOutUser();
    localStorage.removeItem("token");
    navigate("/");
    window.location.reload();
  };

  const mobileNavLinks = (
    <>
      <Link to="/about-us" className="nav-link">
        <span>About Us</span>
      </Link>
      <Dropdown title="Services">
        <DropdownItem to="/all-product">Rent Lease Sale</DropdownItem>
        <DropdownItem to="/innovative-farming-solutions">
          Progressive Farming
        </DropdownItem>
        <DropdownItem to="/hire-farm-labour">Hire Farm Labour</DropdownItem>
        <DropdownItem to="/farmer-shop">Farmer's Shop</DropdownItem>
        <DropdownItem to="/drone-booking">Drone Services</DropdownItem>
      </Dropdown>
      <Dropdown title="Partner Login">
        <div className="dropdown-column flex-fill">
          <DropdownItem className="dropdown-link">
            <Link
              to="https://admin.farmerscity.in/auth"
              style={{ color: "#000000" }}
            >
              <span className="d-inline-flex align-items-center gap-2">
                <CiCirclePlus size={18} style={{ strokeWidth: 1 }} />
                Join as Vendor
              </span>
            </Link>
          </DropdownItem>
          <DropdownItem to="vendor-form" className="dropdown-link">
            <span className="d-inline-flex align-items-center gap-2">
              <FaWpforms size={18} style={{ strokeWidth: 1 }} />
              Vendor Form
            </span>
          </DropdownItem>
          <DropdownItem to="become-a-franchise" className="dropdown-link">
            <span className="d-inline-flex align-items-center gap-2">
              <CiCirclePlus size={18} style={{ strokeWidth: 1 }} />
              Become Franchise
            </span>
          </DropdownItem>
        </div>
      </Dropdown>
    </>
  );

  const desktopNavLinks = (
    <>
      <Link to="/about-us" className="nav-link">
        <strong>About Us</strong>
      </Link>
      {/* <Dropdown title="Services">
        <DropdownItem to="/all-product">Rent Lease Sale</DropdownItem>
        <DropdownItem to="/innovative-farming-solutions">
          Progressive Farming
        </DropdownItem>
        <DropdownItem to="/hire-farm-labour">Hire Farm Labour</DropdownItem>
        <DropdownItem to="/farmer-shop">Farmer's Shop</DropdownItem>
        <DropdownItem to="/drone-booking">Drone Services</DropdownItem>
      </Dropdown> */}
    </>
  );

  const mobileAuthActions = token ? (
    <>
      <div className="mobile-user-actions">
        <DropdownItem to="/wishlist">
          <span className="d-inline-flex align-items-center gap-2">
            <UserIcon /> Wishlist
          </span>
        </DropdownItem>
        <DropdownItem to="/orders">
          <span className="d-inline-flex align-items-center gap-2">
            {" "}
            <img src={cartIcon} alt="Orders" width={24} height={24} /> Orders
          </span>
        </DropdownItem>
        <DropdownItem onClick={handleLogout}>
          <span className="d-inline-flex align-items-center gap-2">
            <LogoutIcon /> Logout
          </span>
        </DropdownItem>
      </div>
      <a href="https://admin.farmerscity.in/auth" className="btn btn-vendor">
        <img src={plus} alt="plus icon" />
        Join as Vendor
      </a>
      {/* <a href="become-a-franchise" className="btn btn-vendor">
        <img src={plus} alt="plus icon" />
        Become Franchise
      </a> */}
      <Link to="/become-a-franchise" className="btn btn-login">
        <img src={plus} alt="plus icon" />
        Become Franchise
      </Link>
    </>
  ) : (
    <>
      <Link to="/signin" className="btn btn-login">
        LOGIN
      </Link>
    </>
  );

  const desktopAuthActions = token ? (
    <>
      {/* <a href="https://admin.farmerscity.in/auth" className="btn btn-vendor">
        <img src={plus} alt="plus icon" />
        Join as Vendor
      </a>
      <a href="become-a-franchise" className="btn btn-vendor">
        <img src={plus} alt="plus icon" />
        Become Franchise
      </a> */}
      <Link to="/cart" className="icon-link">
        <img src={cartIcon} alt="Cart" height={24} width={24} />
      </Link>
      <Dropdown icon={<UserIcon />}>
        <div className="dropdown-menu-custom d-flex gap-4 px-4 py-3">
          {/* Column 1: Your Account */}
          <div className="dropdown-column flex-fill">
            <p className="dropdown-title mb-2">Your Account</p>
            <DropdownItem to="/wishlist" className="dropdown-link">
              <span className="d-inline-flex align-items-center gap-2">
                <FaRegHeart size={18} style={{ strokeWidth: 2 }} /> Wishlist
              </span>
            </DropdownItem>
            <DropdownItem to="/orders" className="dropdown-link">
              <span className="d-inline-flex align-items-center gap-2">
                {" "}
                <img src={cartIcon} alt="Orders" width={18} height={18} />{" "}
                Orders
              </span>
            </DropdownItem>
            <DropdownItem onClick={handleLogout} className="dropdown-link">
              <span className="d-inline-flex align-items-center gap-2">
                <LogoutIcon /> Logout
              </span>
            </DropdownItem>
          </div>

          {/* Column 2: Partner Login */}
          <div className="dropdown-column flex-fill">
            <p className="dropdown-title mb-2">Partner Login</p>
            <DropdownItem className="dropdown-link">
              <Link
                to="https://admin.farmerscity.in/auth"
                style={{ color: "#000000" }}
              >
                <span className="d-inline-flex align-items-center gap-2">
                  <CiCirclePlus size={18} style={{ strokeWidth: 2 }} />
                  Join as Vendor
                </span>
              </Link>
            </DropdownItem>

            <DropdownItem to="/vendor-form" className="dropdown-link">
              <span className="d-inline-flex align-items-center gap-2">
                <FaWpforms size={18} style={{ strokeWidth: 2 }} />
                Vendor Form
              </span>
            </DropdownItem>
            <DropdownItem to="/become-a-franchise" className="dropdown-link">
              <span className="d-inline-flex align-items-center gap-2">
                <CiCirclePlus size={18} style={{ strokeWidth: 2 }} />
                Become Franchise
              </span>
            </DropdownItem>
          </div>
        </div>
      </Dropdown>
    </>
  ) : (
    <Dropdown title="Login" className="btn">
      <div className="dropdown-menu-custom d-flex gap-4 px-4 py-3">
        {/* Column 1: Your Account */}
        <div className="dropdown-column flex-fill">
          <p className="dropdown-title mb-2">Your Account</p>
          <DropdownItem to="/signin" className="dropdown-link">
            <span className="d-inline-flex align-items-center gap-2">
              <UserIcon /> Wishlist
            </span>
          </DropdownItem>
          <DropdownItem to="/signin" className="dropdown-link">
            <span className="d-inline-flex align-items-center gap-2">
              {" "}
              <img src={cartIcon} alt="Orders" width={24} height={24} /> Orders
            </span>
          </DropdownItem>
          <DropdownItem to="/signin" className="dropdown-link">
            <span className="d-inline-flex align-items-center gap-2">
              <LogoutIcon /> Login
            </span>
          </DropdownItem>
        </div>

        {/* Column 2: Partner Login */}
        <div className="dropdown-column flex-fill">
          <p className="dropdown-title mb-2">Partner Login</p>
          <DropdownItem className="dropdown-link">
            <Link
              to="https://admin.farmerscity.in/auth"
              style={{ color: "#000000" }}
            >
              <span className="d-inline-flex align-items-center gap-2">
                <CiCirclePlus size={18} style={{ strokeWidth: 1 }} />
                Join as Vendor
              </span>
            </Link>
            e
          </DropdownItem>

          <DropdownItem to="/venodr-form" className="dropdown-link">
            <span className="d-inline-flex align-items-center gap-2">
              <FaWpforms size={18} style={{ strokeWidth: 1 }} />
              Vendor Form
            </span>
          </DropdownItem>
          <DropdownItem to="/become-a-franchise" className="dropdown-link">
            <span className="d-inline-flex align-items-center gap-2">
              <CiCirclePlus size={18} style={{ strokeWidth: 1 }} />
              Become Franchise
            </span>
          </DropdownItem>
        </div>
      </div>
    </Dropdown>
  );

  return (
    <>
      <header className="navbar-header">
        <div className="container d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <Link to="/" className="navbar-logo d-flex align-items-center">
              {/* Desktop Logo */}
              <img
                src={logo}
                alt="Farmer's City Logo"
                className="d-none d-lg-block"
                height="40"
              />

              {/* Mobile Logo */}
              <img
                src={mobilelogo}
                alt="Farmer's City Logo"
                className="d-lg-none"
                height="32"
              />
            </Link>
            <div className="search-container" ref={searchWrapperRef}>
              <div className="search-input-wrapper  ms-0">
                <SearchIcon />
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search products here..."
                  value={productsSearch}
                  onFocus={() => setShowSearchDropdown(true)}
                  onChange={(e) => {
                    setProductsSearch(e.target.value);
                    setShowSearchDropdown(true);
                  }}
                />
              </div>
              {showSearchDropdown && productsSearch && (
                <div className="search-dropdown">
                  <ul className="search-results-list">
                    {searchData.length > 0 ? (
                      searchData.map((item, index) => (
                        <li
                          key={index}
                          className="search-result-item"
                          onClick={() => {
                            const path =
                              item.productType === "seed"
                                ? `/product-details/${item._id}`
                                : `/profile-details/${item._id}`;
                            navigate(path);
                            setShowSearchDropdown(false);
                            setProductsSearch("");
                          }}
                        >
                          <img
                            src={item.images[0]}
                            alt={item.name}
                            className="result-image"
                          />
                          <span className="result-name">{item.name}</span>
                        </li>
                      ))
                    ) : (
                      <li className="search-no-results">No matches found</li>
                    )}
                  </ul>
                </div>
              )}
            </div>
          </div>

          <nav className="d-none d-lg-flex align-items-center gap-3">
            {desktopNavLinks}
            <div className="auth-actions">{desktopAuthActions}</div>
          </nav>

          <button
            className="d-lg-none mobile-menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
          </button>
        </div>
      </header>

      <div
        className={`mobile-nav-overlay ${isMenuOpen ? "is-open" : ""}`}
        onClick={() => setIsMenuOpen(false)}
      ></div>
      <div className={`mobile-nav-drawer ${isMenuOpen ? "is-open" : ""}`}>
        <div className="mobile-nav-header">
          <Link to="/" className="navbar-logo d-flex align-items-center">
            {/* Desktop Logo */}
            <img src={logo} alt="Farmer's City Logo" height="40" />
          </Link>
          <button
            className="mobile-menu-close-btn"
            onClick={() => setIsMenuOpen(false)}
          >
            <CloseIcon />
          </button>
        </div>

        {/* Corrected: Use mobile-specific variables */}
        <div className="mobile-nav-body">
          <nav className="mobile-nav-links">{mobileNavLinks}</nav>
          <div className="mobile-auth-actions">{mobileAuthActions}</div>
        </div>
      </div>
    </>
  );
};

export default CommonNavbar;
